import React from "react";

export function Fas({ type, className, id }: { type: string, className?: string, id?: string }) {
    return <i className={`fas fa-${type} ${className}`} id={id} ></i>
}